(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name BotonformController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('BotonformController', BotonformController);

    BotonformController.$inject = ["$timeout","$location",'$anchorScroll','$uibModal','$window','AnaliticaService'];

    function BotonformController($timeout,$location,$anchorScroll,$uibModal,$window,AnaliticaService)
    {
    	var vm = this;
        
        vm.modalSol = "";
        vm.abrirForm = function(form_slug){
	        vm.modalSol = $uibModal.open({
	              animation: true,
	              ariaLabelledBy: 'modal-title-top',
	              ariaDescribedBy: 'modal-body-top',
	              templateUrl: 'solicitudpdf.html',
	              size: 'lg',
	              backdrop:'static',
	              controller: function($scope) {
	                    $scope.form_slug = form_slug;
	                    $timeout(function(){
	                    	$.material.checkbox();
	                    },100)
		                $scope.okForm = function(){
		                    vm.modalSol.close();
		                }
		                $scope.koForm = function(){
		                    vm.modalSol.close();
		                }
	               
	              }
	        });
	        AnaliticaService.pageView('Form envio: '+form_slug,$window.location.pathname+'/form-opened',$window.location.pathname+'/form-opened');

        }
    }


})();